import styled from 'styled-components';

import { SectionContainer } from '../styled';

const CartContainer = styled(SectionContainer)``;

export default CartContainer;
